/// <reference path="../../../Modules/Attr/Dialog/NoboxEntityDialog.ts" />
namespace Nobox.NoBoxCRM {

    @Serenity.Decorators.registerClass()
    @Serenity.Decorators.panel()
    export class FormresultsDialog extends NoboxEntityDialog<FormresultsRow, any> {
        protected getFormKey() { return FormresultsForm.formKey; }
        protected getIdProperty() { return FormresultsRow.idProperty; }
        protected getLocalTextPrefix() { return FormresultsRow.localTextPrefix; }
        protected getNameProperty() { return FormresultsRow.nameProperty; }
        protected getService() { return FormresultsService.baseUrl; }
        protected getDeletePermission() { return FormresultsRow.deletePermission; }
        protected getInsertPermission() { return FormresultsRow.insertPermission; }
        protected getUpdatePermission() { return FormresultsRow.updatePermission; }

        protected form = new FormresultsForm(this.idPrefix);
        protected lblElm = `<label class="caption" for="forId">Data</label>`;
        protected inpElm = `<input id="inpId" name="inpName" type="text" class="editor" placeholder="inpPHolder"/>`;
        protected divElm = `<div id="inpId" class="editor s-Serenity-ImageUploadEditor s-ImageUploadEditor" placeholder="inpPHolder"></div>`;
        protected txtAreaElm = `<textarea id="inpId" name="inpName" class="" placeholder="inpPHolder"></textarea>`;
        protected tambahanElm = `<div class="vx"></div><div class="clear"></div>`;
        protected dataEdit = {} as any;
        protected totalPriceAllProducts = 0 as number;

        loadEntity(entity: FormresultsRow) {
            super.loadEntity(entity);
            if (this.isEditMode()) {
                //set total harga pertama
                let totalPrice = 0;
                if (entity.Products != null) {
                    entity.Products.forEach(fy => {
                        totalPrice += fy.FinalTotalPrice;
                    })
                }
                this.totalPriceAllProducts = totalPrice;

                //set total harga jika ada perubahan
                this.form.Products.callbackTotal = (total) => {
                    this.totalPriceAllProducts = total;
                    this.doCalculate();
                }

                let objData = JSON.parse(entity.Data);
                if (objData.typeForm == "basic") {
                    this.form.Products.element.closest('.category').toggle(false);
                    this.form.Order.element.closest('.category').toggle(false);
                }
                this.renderElm(objData);
                this.doCalculate();
                this.form.AdditionalPrice.getGridField().find('input').on('keyup', () => {
                    this.doCalculate();
                });
                this.form.ReductionPrice.getGridField().find('input').on('keyup', () => {
                    this.doCalculate();
                });
            }
        }

        updateInterface() {
            super.updateInterface();
            if (this.isNew()) {
                this.element.find(".search-inbox").hide();
                this.element.find(".follow-up").hide();
            }
            if (this.isEditMode()) {
                this.element.find(".search-inbox").show();
                this.element.find(".follow-up").show();
            }
        }

        getToolbarButtons() {
            var buttons = super.getToolbarButtons();
            buttons.push({
                title: this.getButtonTitle("To Inbox"),
                cssClass: "search-inbox",
                icon: "fa-inbox text-primary",
                separator: true,
                onClick: () => {
                    Q.serviceRequest("/Services/NoBoxCRM/Formresults/GetRoomId", {
                        TemplateId: `${this.entity.FormId}`,
                        ResultId: `${this.get_entityId()}`,
                        IdExt: `${this.entity.Phone}`
                    }, (res: any) => {
                        window.open(res.Url);
                    })
                }
            });
            buttons.push({
                title: this.getButtonTitle("Follow Up"),
                cssClass: "follow-up",
                icon: "fa-comment",
                separator: true,
                onClick: () => {
                    var dlg = new FormFollowUpDialog();
                    dlg.formResultEntity = this.get_entity();
                    dlg.loadByIdAndOpenDialog(this.get_entityId());
                }
            });
            return buttons;
        }

        getSaveEntity() {
            var entity = super.getSaveEntity();
            if (this.dataEdit.typeForm != "basic") {
                var listPdt = []
                entity.Products.forEach((w) => {
                    let jmlh = w.Quantity;
                    delete w.Quantity;
                    listPdt.push({
                        jml: jmlh,
                        pdt: w
                    });
                })
                this.dataEdit.dataPdt = listPdt;

                this.dataEdit.dataCustom = {
                    additional: this.form.Additional.value,
                    additionalPrice: this.form.AdditionalPrice.value,
                    reduction: this.form.Reduction.value,
                    reductionPrice: this.form.ReductionPrice.value,
                    currency: JSON.parse($("#ScriptDefault").text()).Currencies
                }
            }
            let cusName = this.dataEdit.dataField.filter(c => c.id == 1);
            if (cusName) {
                entity.SenderNm = cusName[0].value;
            }
            let cusPhone = this.dataEdit.dataField.filter(c => c.id == 2);
            if (cusPhone) {
                entity.Phone = cusPhone[0].value;
            }

            delete entity.Order;
            delete entity.Additional;
            delete entity.AdditionalPrice;
            delete entity.Reduction;
            delete entity.ReductionPrice;
            delete entity.GrandTotal;
            entity.Data = JSON.stringify(this.dataEdit);
            return entity;
        }

        isValidJSON(jsonString) {
            try {
                JSON.parse(jsonString);
                return true;
            } catch (error) {
                return false;
            }
        }

        renderElm(obj: any) {
            this.element.parents("field").removeClass("field").addClass("fieldCustom")
            let frmData = this.form.Data.element;
            let $this = this;
            frmData.html("");
            frmData.addClass("rowCustom row");
            frmData.parent().css("overflow-x", "hidden");
            //render customer data
            this.dataEdit = obj;
            let dataField = obj.dataField as Array<form>;
            dataField.forEach((fy, yz) => {
                if (fy.isShow) {
                    var elm = `<div class="field field-${fy.id} col-md-6 col-sm-12">`;
                    let set = fy.settings;
                    let editor;
                    let idField;
                    switch (set.field) {
                        case "input":
                            idField = `${set.field}-${set.inputType}-${fy.id}`;
                            elm += this.lblElm.replace("Data", set.label).replace("forId", idField);
                            switch (set.inputType) {
                                case "text":
                                    elm += this.inpElm.replace("inpId", idField).replace("inpName", idField).replace("inpPHolder", set.placeHolder);
                                    elm += this.tambahanElm + `</div>`;
                                    frmData.append(elm);
                                    editor = new Serenity.StringEditor($(`#${idField}`));
                                    Serenity.EditorUtils.setRequired(editor, set.required);
                                    editor.value = fy.value;
                                    editor.change(() => {
                                        this.dataEdit.dataField[yz].value = editor.value;
                                    });
                                    break;
                                case "number":
                                    elm += this.inpElm.replace("inpId", idField).replace("inpName", idField).replace("inpPHolder", set.placeHolder);
                                    elm += this.tambahanElm + `</div>`;
                                    frmData.append(elm);
                                    editor = new Serenity.StringEditor($(`#${idField}`));
                                    Serenity.EditorUtils.setRequired(editor, set.required);
                                    editor.value = fy.value;
                                    editor.change(() => {
                                        this.dataEdit.dataField[yz].value = editor.get_value();
                                    });
                                    break;
                                case "email":
                                    elm += this.inpElm.replace("inpId", idField).replace("inpName", idField).replace("inpPHolder", set.placeHolder);
                                    elm += this.tambahanElm + `</div>`;
                                    frmData.append(elm);
                                    editor = new Serenity.EmailAddressEditor($(`#${idField}`));
                                    Serenity.EditorUtils.setRequired(editor, set.required);
                                    editor.value = fy.value;
                                    editor.change(() => {
                                        this.dataEdit.dataField[yz].value = editor.get_value();
                                    });
                                    break;
                                case "order":
                                    elm += this.inpElm.replace("inpId", idField).replace("inpName", idField).replace("inpPHolder", set.placeHolder);
                                    elm += this.tambahanElm + `</div>`;
                                    frmData.append(elm);
                                    editor = new Serenity.IntegerEditor($(`#${idField}`));
                                    Serenity.EditorUtils.setRequired(editor, set.required);
                                    editor.value = fy.value;
                                    editor.change(() => {
                                        this.dataEdit.dataField[yz].value = editor.get_value();
                                    });
                                    break;
                                case "date":
                                    elm += this.inpElm.replace("inpId", idField).replace("inpName", idField).replace("inpPHolder", set.placeHolder);
                                    elm += this.tambahanElm + `</div>`;
                                    frmData.append(elm);
                                    editor = new CustomDatePickerEditor($(`#${idField}`), { timeZone: null });
                                    Serenity.EditorUtils.setRequired(editor, set.required);
                                    editor.value = fy.value;
                                    editor.change(() => {
                                        this.dataEdit.dataField[yz].value = editor.get_value();
                                    });
                                    break;
                                case "time":
                                    elm += `<input id="${idField}" name="${idField}" type="text" placeholder="${set.placeHolder}" class="editor custom-timepicker-editor"/>`;
                                    elm += this.tambahanElm + `</div>`;
                                    frmData.append(elm);
                                    editor = new CustomTimePickerEditor($(`#${idField}`), { hideLabel: false, enable: true, containerClass: null, fromFrmRs: true });
                                    Serenity.EditorUtils.setRequired(editor, set.required);
                                    editor.set_value(fy.value);
                                    editor.change(() => {
                                        this.dataEdit.dataField[yz].value = editor.get_value();
                                    });
                                    break;
                                case "url":
                                    elm += this.inpElm.replace("inpId", idField).replace("inpName", idField).replace("inpPHolder", set.placeHolder);
                                    elm += this.tambahanElm + `</div>`;
                                    frmData.append(elm);
                                    editor = new Serenity.URLEditor($(`#${idField}`));
                                    Serenity.EditorUtils.setRequired(editor, set.required);
                                    editor.value = fy.value;
                                    editor.change(() => {
                                        this.dataEdit.dataField[yz].value = editor.get_value();
                                    });
                                    break;
                                case "checkbox":
                                    elm += "<div class='col p-0'>"
                                    set.selectOpsi.forEach(xy => {
                                        let cek = null;
                                        if (fy.value.findIndex(pr => pr == xy.id) != -1) {
                                            cek = "checked";
                                        }
                                        elm += `<div class="custom-control custom-checkbox mt-1 mr-2">
                                    <input type="checkbox" id="checkbox-${xy.id}" value="${xy.id}" name="checkboxResult-${fy.id}" class="custom-control-input inpCheckbox" ${cek}>
                                    <label class="custom-control-label" for="checkbox-${xy.id}">${xy.name}</label>
                                    </div>`
                                    })
                                    elm += `</div></div>`;
                                    frmData.append(elm);

                                    this.element.find(`input[name='checkboxResult-${fy.id}']`).on("change", function () {
                                        var selectedValues = [];
                                        // Use :checkbox selector to select all checkboxes
                                        $(`input[name="checkboxResult-${fy.id}"]:checkbox:checked`).each(function () {
                                            // Add the value of each checked checkbox to the array
                                            selectedValues.push($(this).val());
                                        });
                                        $this.dataEdit.dataField[yz].value = selectedValues;
                                    })
                                    break;
                                case "radio":
                                    elm += "<div class='col p-0'>"
                                    set.selectOpsi.forEach(xy => {
                                        let cek = null;
                                        if (xy.id == fy.value) {
                                            cek = "checked";
                                        }
                                        elm += `<div class="custom-control custom-radio mt-1 mr-2">
                                    <input type="radio" id="radio-${xy.id}" value="${xy.id}" name="radioResult-${fy.id}" class="custom-control-input inpRadio" ${cek}>
                                    <label class="custom-control-label" for="radio-${xy.id}">${xy.name}</label>
                                    </div>`
                                    })
                                    elm += `</div></div>`;
                                    frmData.append(elm);

                                    this.element.find(`input[name='radioResult-${fy.id}']`).on("change", function () {
                                        $this.dataEdit.dataField[yz].value = $(this).attr("value");
                                    })
                                    break;
                                case "file":
                                    elm += this.divElm.replace("inpId", idField).replace("inpName", idField);
                                    elm += this.tambahanElm + `</div>`;
                                    frmData.append(elm);
                                    editor = new Serenity.FileUploadEditor($(`#${idField}`), { allowNonImage: true });
                                    Serenity.EditorUtils.setRequired(editor, set.required);
                                    let initFile = false;
                                    $(`#${idField}`).find("ul").on("DOMNodeInserted", function () {
                                        if (initFile == false) {
                                            initFile = true;
                                            $('ul li.file-item.file-image').each(function () {
                                                var elIMage = $(this).find(".thumb ");
                                                $(this).find(".thumb ").removeAttr("style");
                                                $(this).find(".thumb ").css("overflow", "hidden");
                                                var image = elIMage.attr("href");
                                                elIMage.html(`<img src="${image}" style = "height: 100%;width: auto;overflow: hidden;margin:auto;" >`);
                                            });
                                            initFile = false;
                                            $this.dataEdit.dataField[yz].value = JSON.stringify(editor.get_value());
                                        }
                                    });
                                    if (!Q.isEmptyOrNull(fy.value)) {
                                        editor.value = JSON.parse(fy.value).Filename;
                                    }
                                    break;
                                case "fileMulti":
                                    elm += this.divElm.replace("inpId", idField).replace("inpName", idField);
                                    elm += this.tambahanElm + `</div>`;
                                    frmData.append(elm);
                                    editor = new Serenity.MultipleFileUploadEditor($(`#${idField}`), { allowNonImage: true, });
                                    Serenity.EditorUtils.setRequired(editor, set.required);
                                    let initFiles = false;
                                    $(`#${idField}`).find("ul").css({
                                        "display": "flex",
                                        "gap": "5px"
                                    });
                                    $(`#${idField}`).find("ul").on("DOMNodeInserted", function () {
                                        if (initFiles == false) {
                                            initFiles = true;
                                            $('ul li.file-item.file-image').each(function () {
                                                var elIMage = $(this).find(".thumb ");
                                                $(this).find(".thumb ").removeAttr("style");
                                                $(this).find(".thumb ").css("overflow", "hidden");
                                                var image = elIMage.attr("href");
                                                elIMage.html(`<img src="${image}" style = "height: 100%;width: auto;overflow: hidden;margin:auto;" >`);
                                            });
                                            initFiles = false;
                                            $this.dataEdit.dataField[yz].value = JSON.stringify(editor.get_value());
                                        }
                                    });
                                    if (!Q.isEmptyOrNull(fy.value)) {
                                        editor.value = JSON.parse(fy.value);
                                    }
                                    break;
                            }
                            break;
                        case "textarea":
                            idField = `textarea-${fy.id}`;
                            elm += this.lblElm.replace("Data", set.label).replace("forId", idField);
                            elm += this.txtAreaElm.replace("inpId", idField).replace("inpName", idField).replace("inpPHolder", set.placeHolder);
                            elm += this.tambahanElm + `</div>`;
                            frmData.append(elm);
                            editor = new Serenity.TextAreaEditor($(`#${idField}`), { rows: 3 });
                            Serenity.EditorUtils.setRequired(editor, set.required);
                            editor.value = fy.value;
                            editor.change(() => {
                                this.dataEdit.dataField[yz].value = editor.value;
                            });
                            break;
                        case "select":
                            if (fy.id == 6) {
                                idField = `select-${fy.id}`;
                                elm += this.lblElm.replace("Data", set.label).replace("forId", idField);
                                elm += this.inpElm.replace("inpId", idField).replace("inpName", idField).replace("inpPHolder", set.placeHolder);
                                elm += this.tambahanElm + `</div>`;
                                frmData.append(elm);
                                editor = new Serenity.ServiceLookupEditor($(`#${idField}`), { idField: "Id", textField: "Name", service: "/Services/Master/Countries/List" } as Serenity.ServiceLookupEditorOptions);
                                Serenity.EditorUtils.setRequired(editor, set.required);
                                if (!Q.isEmptyOrNull(fy.value) && this.isValidJSON(fy.value)) {
                                    let objVal = JSON.parse(fy.value);
                                    editor.set_value(objVal.id);
                                }
                                editor.change(() => {
                                    this.dataEdit.dataField[yz].value = JSON.stringify({ id: editor.get_value(), text: editor.text });
                                });
                            } else if (fy.id == 7) {
                                idField = `select-${fy.id}`;
                                elm += this.lblElm.replace("Data", set.label).replace("forId", idField);
                                elm += this.inpElm.replace("inpId", idField).replace("inpName", idField).replace("inpPHolder", set.placeHolder);
                                elm += this.tambahanElm + `</div>`;
                                frmData.append(elm);
                                editor = new Serenity.ServiceLookupEditor($(`#${idField}`), { idField: "Id", textField: "Name", service: "/Services/Master/States/List" } as Serenity.ServiceLookupEditorOptions);
                                Serenity.EditorUtils.setRequired(editor, set.required);
                                if (!Q.isEmptyOrNull(fy.value) && this.isValidJSON(fy.value)) {
                                    let objVal = JSON.parse(fy.value);
                                    editor.set_value(objVal.id);
                                }
                                editor.change(() => {
                                    this.dataEdit.dataField[yz].value = JSON.stringify({ id: editor.get_value(), text: editor.text });
                                });
                            } else if (fy.id == 8) {
                                idField = `select-${fy.id}`;
                                elm += this.lblElm.replace("Data", set.label).replace("forId", idField);
                                elm += this.inpElm.replace("inpId", idField).replace("inpName", idField).replace("inpPHolder", set.placeHolder);
                                elm += this.tambahanElm + `</div>`;
                                frmData.append(elm);
                                editor = new Serenity.ServiceLookupEditor($(`#${idField}`), { idField: "Id", textField: "Name", service: "/Services/Master/Cities/List" } as Serenity.ServiceLookupEditorOptions);
                                Serenity.EditorUtils.setRequired(editor, set.required);
                                if (!Q.isEmptyOrNull(fy.value) && this.isValidJSON(fy.value)) {
                                    let objVal = JSON.parse(fy.value);
                                    editor.set_value(objVal.id);
                                }
                                editor.change(() => {
                                    this.dataEdit.dataField[yz].value = JSON.stringify({ id: editor.get_value(), text: editor.text });
                                });
                            } else {
                                idField = `select-${fy.id}`;
                                elm += this.lblElm.replace("Data", set.label).replace("forId", idField);
                                elm += this.inpElm.replace("inpId", idField).replace("inpName", idField).replace("inpPHolder", set.placeHolder);
                                elm += this.tambahanElm + `</div>`;
                                frmData.append(elm);
                                editor = new FormCustomEditor($(`#${idField}`));
                                editor.setOpt(set.selectOpsi);
                                Serenity.EditorUtils.setRequired(editor, set.required);
                                if (!Q.isEmptyOrNull(fy.value) && this.isValidJSON(fy.value)) {
                                    let objVal = JSON.parse(fy.value);
                                    editor.set_value(objVal.id);
                                }
                                editor.change(() => {
                                    this.dataEdit.dataField[yz].value = JSON.stringify({ id: editor.get_value(), text: editor.text });
                                });
                            }
                            break;
                    }
                }
            });

            if (obj.typeForm != "basic") {
                //render payment method
                let frmOrder = this.form.Order.element;
                frmOrder.html("");
                frmOrder.addClass("rowCustom row");
                frmOrder.parent().css("overflow-x", "hidden");
                let listPayment = obj.dataPay.list as Array<FormpaymentsRow>;
                let listOpsiPayment = [];
                listPayment.forEach((x) => {
                    listOpsiPayment.push({
                        id: x.Id.toString(),
                        name: x.Name
                    });
                })
                var elm = `<div class="field field-payment col-md-6 col-sm-12">`;
                let editor;
                elm += this.lblElm.replace("Data", "Payment Method");
                elm += this.inpElm.replace("inpId", `select-payment`);
                elm += `</div>`;
                frmOrder.append(elm);
                editor = new FormCustomEditor($(`#select-payment`));
                editor.setOpt(listOpsiPayment);
                editor.set_value(obj.dataPay.selected);
                editor.change(() => {
                    let val = editor.get_value();
                    let objPay = listPayment.filter(c => c.Id == val);
                    if (objPay.length) {
                        this.dataEdit.dataPay.selected = val;
                        this.dataEdit.dataPay.type = objPay[0].Type + 1;
                    }
                });

                //render coupon
                if (obj.dataCoupon) {
                    var elm1 = `<div class="field field-coupon col-md-6 col-sm-12">`;
                    let editor1;
                    elm1 += this.lblElm.replace("Data", "Coupon Code");
                    elm1 += this.inpElm.replace("inpId", `input-coupon`);
                    elm1 += `</div>`;
                    frmOrder.append(elm1);
                    editor1 = new Serenity.StringEditor($(`#input-coupon`));
                    editor1.value = obj.dataCoupon;
                    editor1.change(() => {
                        this.dataEdit.dataCoupon = editor1.value;
                    });
                }

                //render data custom
                this.form.Additional.getGridField().toggle(true);
                this.form.AdditionalPrice.getGridField().toggle(true);
                this.form.Reduction.getGridField().toggle(true);
                this.form.ReductionPrice.getGridField().toggle(true);
                if (this.element.find(".btn-currency").length) {
                    this.element.find(".btn-currency").remove();
                }
                let currency = JSON.parse($("#ScriptDefault").text()).Currencies;
                $(`<div class="inplace-button btn-currency ml-0 mr-1"><p>${currency}</p></div>`)
                    .attr("title", "Currency")
                    .insertBefore(this.form.AdditionalPrice.element);
                $(`<div class="inplace-button btn-currency ml-0 mr-1"><p>${currency}</p></div>`)
                    .attr("title", "Currency")
                    .insertBefore(this.form.ReductionPrice.element);
                let objCustom = obj.dataCustom;
                if (objCustom) {
                    if (objCustom.additional)
                        this.form.Additional.value = objCustom.additional;
                    if (objCustom.additionalPrice)
                        this.form.AdditionalPrice.value = objCustom.additionalPrice;
                    if (objCustom.reduction)
                        this.form.Reduction.value = objCustom.reduction;
                    if (objCustom.reductionPrice)
                        this.form.ReductionPrice.value = objCustom.reductionPrice;
                }
                $(`<div class="inplace-button btn-currency ml-0 mr-1"><p>${currency}</p></div>`)
                    .attr("title", "Currency")
                    .insertBefore(this.form.GrandTotal.element);
            } else {
                this.form.Additional.getGridField().toggle(false);
                this.form.AdditionalPrice.getGridField().toggle(false);
                this.form.Reduction.getGridField().toggle(false);
                this.form.ReductionPrice.getGridField().toggle(false);
            }
        }

        doCalculate() {
            let total = this.totalPriceAllProducts + Number((this.form.AdditionalPrice.get_value() ?? 0)) - Number((this.form.ReductionPrice.get_value() ?? 0));
            this.form.GrandTotal.set_value(total);
        }
    }
}